import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class MerchantdirService {

    constructor(private http: Http, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }
    //httpExtensionService  should be used if you start doing some authorized calls in the service
    getCategories() {
        return this.http.get(this.config.apiURI + this.config.categoriesList)
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    getActiveCategories(marketId) {
        return this.http.get(this.config.apiURI + this.config.getActiveCategoriesList(marketId))
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    getActiveOrderedCategories() {
        return this.http.get(this.config.apiURIv2 + this.config.getActiveOrderedCategoriesList())
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    getSearchResults(body) {
        let headers = new Headers();
        let user_token: string = this.sessionService.getToken();
        if(user_token) {
            //headers.append('Authorization', 'Bearer ' + user_token);
        }
        return this.http.post(this.config.apiURIv2 + this.config.getSearchResults, body, {
            headers: headers
        })
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    getLocationDetails(id) {
        let headers = new Headers();
        return this.http.get(this.config.apiURIv2 + this.config.getLocationDetails(id), {
            headers: headers
        })
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    getLocationOffers(id, body) {
        let headers = new Headers();
        return this.http.post(this.config.apiURIv2 + this.config.getLocationOffers(id), body, {
            headers: headers
        })
            .map((data: Response) => data.json())
            .catch(this.handleError);
    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }

    getMerchantLocation(id, bid) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getMerchantLocation(id, bid), {
            headers: headers
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/merchantdir.service.ts